module.exports = __webpack_public_path__ + "static/media/shiny_neuron_4.3bff34e7.svg";